import { CommonPaths } from '@utils/path-common'

import { NameDto } from './NameDto'
import { TickmillProductType } from './TickmillProductType'

export interface LandingPageDto {
  id: string
  name: string
  promoMaterialBaseUrl: NameDto
  url: string
  enabled: boolean
  imagePath: string
  tickmillCompany: NameDto
  language: {
    id: string
    name: string
  }
}

export interface ClientLandingPageSettingDto {
  tickmillProductId: TickmillProductType
  landingPages: ClientLandingPageDto[]
}

export interface ClientLandingPageDto {
  id: number
  name: string
  selected: boolean
  isIntroducingBroker: boolean
}

export enum ETDLandingPageID {
  TradersRoomBalances = 300,
  TradersRoomETDTransactionHistory = 301,
  SubscriptionsPlatforms = 400,
  SubscriptionsMarketData = 401,
  SubscriptionsHistory = 402,
  ETDStatements = 500,
}

export enum CFDLandingPageID {
  TradersRoomWallets = 100,
  TradersRoomTradingAccounts = 101,
  TradersRoomTransactionHistory = 102,
  IntroducingBrokerWallets = 200,
  IntroducingBrokerClients = 201,
  IntroducingBrokerIncome = 202,
  IntroducingBrokerReports = 203,
  IntroducingBrokerTransactionHistory = 204,
  IntroducingBrokerReferralMaterials = 205,
  IntroducingBrokerLegalDocuments = 206,
  IntroducingBrokerSignUp = 207,
  IntroducingBrokerDashboard = 208,
  TraderMarkets = 106,
}

export enum GenericLandingPageID {
  TradersRoomWallets = 103,
  TradersRoomAccounts = 104,
  TradersRoomTransactionHistory = 105,
}
const ETDLandingPage = {
  [ETDLandingPageID.TradersRoomBalances]: CommonPaths.TradersRoomBalances,
  [ETDLandingPageID.TradersRoomETDTransactionHistory]: CommonPaths.TradersRoomTransactionHistory,
  [ETDLandingPageID.SubscriptionsPlatforms]: CommonPaths.SubscriptionsPlatforms,
  [ETDLandingPageID.SubscriptionsMarketData]: CommonPaths.SubscriptionsMarketData,
  [ETDLandingPageID.SubscriptionsHistory]: CommonPaths.SubscriptionsHistory,
  [ETDLandingPageID.ETDStatements]: CommonPaths.ETDStatements,
}

const CFDLandingPage = {
  [CFDLandingPageID.TradersRoomWallets]: CommonPaths.TradersRoomWallets,
  [CFDLandingPageID.TradersRoomTradingAccounts]: CommonPaths.TradersRoomTradingAccounts,
  [CFDLandingPageID.TradersRoomTransactionHistory]: CommonPaths.TradersRoomTransactionHistory,
  [CFDLandingPageID.IntroducingBrokerWallets]: CommonPaths.IntroducingBrokerWallets,
  [CFDLandingPageID.IntroducingBrokerClients]: CommonPaths.IntroducingBrokerClients,
  [CFDLandingPageID.IntroducingBrokerIncome]: CommonPaths.IntroducingBrokerIncome,
  [CFDLandingPageID.IntroducingBrokerReports]: CommonPaths.IntroducingBrokerReports,
  [CFDLandingPageID.IntroducingBrokerTransactionHistory]:
    CommonPaths.IntroducingBrokerTransactionHistory,
  [CFDLandingPageID.IntroducingBrokerReferralMaterials]:
    CommonPaths.IntroducingBrokerReferralMaterials,
  [CFDLandingPageID.IntroducingBrokerLegalDocuments]: CommonPaths.IntroducingBrokerLegalDocuments,
  [CFDLandingPageID.IntroducingBrokerSignUp]: CommonPaths.IntroducingBrokerSignUp,
  [CFDLandingPageID.IntroducingBrokerDashboard]: CommonPaths.IntroducingBrokerDashboard,
  [CFDLandingPageID.TraderMarkets]: CommonPaths.Markets,
}

const GenericLandingPage = {
  [GenericLandingPageID.TradersRoomWallets]: CommonPaths.TradersRoomWallets,
  [GenericLandingPageID.TradersRoomAccounts]: CommonPaths.TradersRoomTradingAccounts,
  [GenericLandingPageID.TradersRoomTransactionHistory]: CommonPaths.TradersRoomTransactionHistory,
}

export const LandingPageMapping = {
  ...ETDLandingPage,
  ...CFDLandingPage,
  ...GenericLandingPage,
}
